import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPowerOff } from '@fortawesome/free-solid-svg-icons';
import { SUCCESS_COLOR } from '@/shared/constants/colors';

export const TOGGLE_ACTIVE_MENU_ITEM_KEY = 'toggleActiveMenuItem';

/**
 * Devuelve el ítem de menú "Activar" / "Inactivar" según record.active.
 *
 * @param {Object} props
 * @param {{ active: boolean }} props.record - Objeto del que se lee la propiedad active
 * @param {(record: Object) => void} props.onActivate - Callback al elegir Activar
 * @param {(record: Object) => void} props.onInactivate - Callback al elegir Inactivar
 * @param {Object} [props.menuItemProps] - Propiedades adicionales del ítem de menú. Los valores enviados para las propiedades `key`,
 * `label`, `icon`, `danger` y `onClick` se ignoran.
 *
 * @returns {Object} Ítem de menú compatible con ActionsDropdown y Dropdown de Ant Design
 */
export const getToggleActiveMenuItem = ({ record, onActivate, onInactivate, ...menuItemProps }) => {
  const isActive = !!record.active;
  const label = isActive ? 'Inactivar' : 'Activar';
  const color = isActive ? undefined : SUCCESS_COLOR;

  return {
    ...menuItemProps,
    key: TOGGLE_ACTIVE_MENU_ITEM_KEY,
    label: label,
    icon: <FontAwesomeIcon icon={faPowerOff} />,
    danger: isActive,
    onClick: () => isActive ? onInactivate(record) : onActivate(record),
    style: { color },
  };
};
